import React, {Component} from "react";
import './movieDetails.css';

class MovieDetails extends Component {

    /**
     * Class constructor
     *
     * @param props
     */
    constructor(props) {
        super(props);
    }


    /**
     * This method runs after the component output has been rendered to the DOM.
     */
    componentDidMount() {
        //debugger;  //allow debugging code
    }


    /**
     * This method render the information (data from previous functions) with HTML code
     * @returns Return page information inside HTML
     */
    render() {
        return (
            <div>

                <div className={'page '} ref={page=> this.page = page} id="filmeDetailPage">
                    <h1 className="modal-title">{this.props.movieobj.props.movie.original_title}</h1>

                    <div className="row">
                        <div className="col-sm-4a">
                            <img src={this.props.movieobj.props.movie.poster_src} width="300" alt={this.props.movieobj.props.movie.title} className="img-margin" />
                        </div>

                        <div className="col-sm-8 movieDetails">
                            <p> <strong>Título: </strong>{this.props.movieobj.props.movie.title}<br />
                                <strong>Título Original: </strong>{this.props.movieobj.props.movie.original_title}<br />
                                <strong>Data estreia: </strong>{this.props.movieobj.props.movie.release_date} </p>

                            <p><strong>Sinopse: </strong><br />{this.props.movieobj.props.movie.overview}</p>

                            <button className="btn btn-info" onClick={this.props.onclickbacktofilms}>Voltar</button>
                            <button className="btn btn-success">Ver filme</button>
                        </div>
                    </div>

                    <div>

                    </div>

                </div>
            </div>
        );
    }
}
export default MovieDetails;
